import { COMPANY_COMMERCIAL_QUERY_PREFIX } from '@/api/company/commercial-query-keys';
import type { EntityType } from './types';

/**
 * Maps entity types to their related query key prefixes.
 * When an entity changes, all queries with these prefixes will be invalidated.
 */
export const entityToQueryKeyMap: Record<EntityType, string[]> = {
  category: ['category', 'cash-movement'],
  company: ['company', 'cash-movement', COMPANY_COMMERCIAL_QUERY_PREFIX],
  account: ['account', 'cash-flow-forecast', 'cash-movement'],
  'cash-movement': [
    'cash-movement',
    'account',
    'cash-flow-forecast',
    'reconciliation',
    'dashboard',
    'onboarding-ai-operations',
    // Incassi della scheda controparte (ultimo incasso, scadenze).
    COMPANY_COMMERCIAL_QUERY_PREFIX,
  ],
  document: [
    'cash-movement',
    'commercial-entitlements',
    'document',
    'document-electronic-events',
    'document-payment-schedule',
    'reconciliation',
    'dashboard',
    'onboarding-ai-operations',
    COMPANY_COMMERCIAL_QUERY_PREFIX,
  ],
  'document-line': [
    'document',
    'cash-movement',
    COMPANY_COMMERCIAL_QUERY_PREFIX,
  ],
  'document-payment-schedule': [
    'document',
    'document-payment-schedule',
    'reconciliation',
    // Riscrivere il piano rate cancella le rate e, per cascade, le
    // allocazioni: senza questa voce la scheda del movimento continuava a
    // mostrare una riconciliazione ormai cancellata.
    'cash-movement',
    'onboarding-ai-operations',
    COMPANY_COMMERCIAL_QUERY_PREFIX,
  ],
  'forecast-series': ['forecast-series', 'forecast'],
  'forecast-occurrence': ['forecast-occurrence', 'forecast', 'reconciliation'],
  'forecast-payment-schedule': [
    'forecast-payment-schedule',
    'forecast',
    'reconciliation',
  ],
  'tenant-vat-rate': ['tenant-vat-rate'],
  'reconciliation-link': [
    'reconciliation',
    'cash-movement',
    'document',
    'onboarding-ai-operations',
    COMPANY_COMMERCIAL_QUERY_PREFIX,
  ],
  'tenant-settings': ['tenant-settings', 'cash-movement'],
  'onboarding-ai-operations': ['onboarding-ai-operations'],
};
